import DOMPurify from 'dompurify';

export const defaultSanitizeConfig = {
    FORCE_BODY: true,
    ALLOWED_ATTR: ['href', 'target', 'rel'], // don't add too many values, the less attribs, more restrictive it is
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'br'], // don't add too many values, the less tags, more restrictive it is
};

const sanitizeHtml = (html: string, config: DOMPurify.Config): string => {
    if (typeof window === 'undefined') return html;
    return DOMPurify.sanitize(html, config);
};

export default sanitizeHtml;
